export default __webpack_public_path__ + "static/media/mockup_feedboost.13e43514.png";